import { DprAttachmentsGridData } from '@shared/models/grid';

export interface DprActivityAttachmentsGridData extends DprAttachmentsGridData {
  dprActivityId?: number;
}
